module.exports = __webpack_public_path__ + "images/marker-station.1e788c.png";